import React, { useEffect, useState } from 'react'
import { Link, useLoaderData } from 'react-router-dom'
import { getCases } from '../../adapters/caseResolution';
import { InputField } from '../../components/Input';
import { LoadingData } from '../../components/Loading';
import Pagination from '../../components/Pagination';
import { formatDate } from '../../utils/methods';

export default function Dashboard() {

  const [searchTxt, setSearchTxt] = useState('');
  const [filteredCases, setFilteredCases] = useState([]);

  const [caseData, setCaseData] = useState(null);
  const [loadingState, setLoadingState] = useState(false);


  const serverData = useLoaderData()

  useEffect(() => {
    setCaseData(serverData)
    if (serverData && serverData.docs) {
      setFilteredCases(serverData?.docs);
    }
  }, [serverData])




  const searchCases = async () => {
    setLoadingState(true);
    const filteredItems = []
    caseData.docs.forEach(async (item) => {
      for await (let ic of item) {
        if (ic.name.includes(searchTxt)) {
          const existsInArray = filteredItems.find((fi) => fi._id === item._id)
          if (!existsInArray) {
            filteredItems.push(item);
          }
        }
      }

      for await (let id of item) {
        if (id.name.includes(searchTxt)) {
          const existsInArray = filteredItems.find((fi) => fi._id === item._id)
          if (!existsInArray) {
            filteredItems.push(item);
          }
        }
      }
    })
    setTimeout(() => {
      if (filteredItems.length) {
        setFilteredCases(filteredItems);
      }
      setLoadingState(false);
    }, 3000)
  }

  
  return (
      <div className="h-screen">
        <div className="wrapper animate__animated animate__fadeIn xl:py-16 py-12">
          {/* Lorem, ipsum dolor sit amet consectetur adipisicing elit. Laboriosam enim vel aliquam facilis maiores repellat cupiditate porro? Temporibus inventore, esse officia possimus, dolor commodi modi est perspiciatis obcaecati repellat ut. */}
          <div className="gradient-bg rounded-lg py-10 px-8 flex lg:items-center lg:flex-row flex-col justify-start lg:justify-between items-start gap-4">
            <div>
              <h1 className="font-fira xl:text-3xl lg:text-2xl text-xl">Dashboard</h1>
              <p className="text-xs lg:text-sm font-taviraj">Resolve your issues easily and risk free</p>
            </div>

          <Link to="/account/create-case" className="text-white bg-blue-800 text-xs font-semibold px-6 py-2 rounded-lg border border-blue-800 hover:border-blue-900 hover:bg-blue-800 ">
            Create New Case
          </Link>
        </div>



        <div className="mt-6">
          <div className="flex items-center md:gap-4 gap-0 md:justify-between justify-center md:flex-row flex-col">
            <div className="md:w-10/12 w-full relative">
              <InputField type='text' name="searchCase" defaultValue={searchTxt} id="searchText" className="" onChange={(e) => {
                setSearchTxt(e.target.value)
              }} withIcon={true} placeholder="Search For a Case By Defendant's Name, Claimant's Name" />
              <span className="absolute top-4 left-3">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                </svg>
              </span>

              {(searchTxt !== '' && searchTxt.length > 3) && <span className="absolute cursor-pointer top-4 right-3" onClick={() => {
                setSearchTxt('');
                searchCases();
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                  <path fillRule="evenodd" d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z" clipRule="evenodd" />
                </svg>
              </span>}
            </div>

            <div className="md:w-2/12 w-full mb-3">
              <button onClick={searchCases} className="w-full text-xs font-semibold bg-blue-800 py-3 rounded-lg hover:bg-blue-900 text-white px-4">
                Search Case
              </button>
            </div>
          </div>
        </div>

        <h4 className="text-lg font-fira mt-3">Case History</h4>
        <div className="mt-2 border-2 overflow-scroll h-96 pb-12 border-gray-300 bg-gray-100 rounded-lg">
          {(Array.from(filteredCases).length > 0) &&
            <>
              <div className="overflow-x-auto">
                <div className="min-w-screen w-full overflow-x-scroll">
                  <table className="min-w-max w-full table-auto">
                    <thead className="text-xs font-fira bg-gray-200 rounded-t-lg">
                      <tr>
                        <th className="py-4 px-8 text-left">#</th>
                        <th className="py-4 px-8 text-left">Claimants</th>
                        <th className="py-4 px-8 text-left">Defendants</th>
                        <th className="py-4 px-8 text-left">Category</th>
                        <th className="py-4 px-8 text-left">Status</th>
                        <th className="py-4 px-8 text-left">Latest Upload</th>
                        <th className="py-4 px-8 text-left"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.from(filteredCases).map((rc) => {
                        return (
                          <tr key={rc._id} className="border-b-2 font-semibold text-xs border-gray-200 hover:bg-gray-100">
                            <td className='py-4 px-8 text-left whitespace-nowrap'>{filteredCases.indexOf(rc) + 1}</td>
                            <td className='py-4 px-8 text-left whitespace-nowrap'>
                              <div className="flex items-center justify-center">
                                {rc.claimants.map((rcc) => {
                                  let index = rc.claimants.findIndex((rci) => rci._id === rcc._id);
                                  return <img key={rcc._id} title={rcc.name} className={`w-8 h-8 rounded-full border-2 border-gray-200 transform hover:scale-125 ${index > 0 ? '-ml-3' : ''}`} src={rcc.avatar} alt="" />
                                })}
                              </div>
                            </td>
                            <td className='py-4 px-8 text-left whitespace-nowrap'>
                              <div className="flex items-center justify-center">
                                {Array.from(rc.defendants).map((rcd) => {
                                  let index = rc.defendants.findIndex((rci) => rci._id === rcd._id);
                                  return (<img key={rcd._id} title={rcd.name} className={`w-8 h-8 rounded-full border-2 border-gray-200 transform hover:scale-125 ${index > 0 ? '-ml-3' : ''}`} src={rcd.avatar} alt="" />)
                                })}
                              </div>
                            </td>
                            <td className='py-4 px-8 text-left whitespace-nowrap'>
                              <span>{rc.category}</span>
                            </td>
                            <td className='py-4 px-8 text-left whitespace-nowrap'>
                              <span>{rc.status}</span>
                            </td>
                            <td className='py-4 px-8 text-left whitespace-nowrap'>
                              <span>{formatDate(rc.updatedAt)}</span>
                            </td>
                            <td className='py-4 px-8 text-left whitespace-nowrap'>
                              <Link to={`/account/case-detail/${rc._id}`} className="border-2 border-blue-600 hover:bg-blue-300 text-blue-800 font-semibold rounded-lg py-1 px-3">
                                See Details
                              </Link>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          }

          {(filteredCases.length < 1 && !loadingState) && <div className="no-case flex py-16 px-6 flex-col justify-center gap-6">
            <div className="text-center">
              <h4 className="font-semibold font-fira text-xl">No Case Record</h4>
              <br />
              <br />
              <p className="text-xs mt-1">Click on the <Link to="/account/create-case" className="text-blue-800" >Create New Case</Link> button to initiate a new case</p>
            </div>
          </div>}
          {loadingState && <div className="mt-10">
            <LoadingData message="Loading Data..." />
          </div>}

        </div>
        <Pagination currentData={caseData} setData={setCaseData} setLoading={setLoadingState} xhrAdapter={getCases} />
      </div>
    </div>
  )
}
